import BodyText, { BODY_TEXT_SIZES } from "@shared/ui/BodyText";
import { SingleSelectDropdown } from "@shared/ui/Dropdowns";
import { Input } from "@shared/ui/Inputs";
import React from "react";
import { useIntl } from "react-intl";

import EmptySpace from "~/components/_emptySpace";

const EstimatedDurationField = ({
  keyPrefix = "pm",
  valueNumber,
  valueUnit,
  unitOptions = [],
  errorMessage = "",
  onNumberChange,
  onUnitChange,
}) => {
  const {
    messages: { preventiveMaintenance: PM },
  } = useIntl();

  const selectedUnit =
    valueUnit && unitOptions.find((option) => option.value === valueUnit)?.label
      ? [
          {
            label: PM?.frequency?.[valueUnit.toLowerCase()] || valueUnit,
            value: valueUnit,
          },
        ]
      : unitOptions.filter((option) => option.value === "Day").slice(0, 1);

  return (
    <>
      <BodyText
        size={BODY_TEXT_SIZES.X_SMALL}
        color="text-secondary"
        className="mb-sm"
      >
        {PM?.form?.estimatedDuration}
      </BodyText>
      <div className="input-group">
        <div className="max-w-[35%] mr-lg mb-sm">
          <Input
            keyId={`${keyPrefix}-estimated-duration-number`}
            type="number"
            value={valueNumber ?? ""}
            placeholder="1"
            min={1}
            errorMessage={errorMessage}
            onKeyDown={(e) => {
              if (e.key === ".") {
                e.preventDefault();
              }
            }}
            onChange={onNumberChange}
          />
        </div>
        <SingleSelectDropdown
          keyId={`${keyPrefix}-estimated-duration-unit`}
          options={unitOptions}
          searchable
          placeholder={PM?.frequency?.day}
          onChange={onUnitChange}
          values={selectedUnit}
        />
      </div>
      <BodyText
        size={BODY_TEXT_SIZES.X_SMALL}
        color="text-secondary"
        className="mt-2xs"
      >
        {PM?.form?.estimatedDurationHelper}
      </BodyText>
      <EmptySpace height="16px" />
    </>
  );
};

export default EstimatedDurationField;
